import apiClient from '../apiClient';
import { GET_PAYMENT_SCHEME_URL } from '../apiUrl';

const getPaymentSchemeApi = () => {
  return apiClient.get(GET_PAYMENT_SCHEME_URL);
};

export default getPaymentSchemeApi;
